var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex h-13" },
    [
      _c("div", { staticClass: "sticky z-10 flex pl-6 bg-slate-100 left-88" }, [
        _c(
          "div",
          {
            staticClass:
              "flex items-center border-b border-l border-r border-slate-400 bg-pure-white",
            class: { "rounded-bl": _vm.isLast }
          },
          [
            _c(
              "div",
              { staticClass: "flex flex-shrink-0 w-20 gap-2 px-4" },
              [
                _c("BlTextBody2", {
                  staticClass: "truncate text-slate-1000",
                  attrs: { text: _vm.appointment.id }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "flex items-center flex-shrink-0 gap-2 px-4 w-60"
              },
              [
                _vm.isOrphan
                  ? _c("BlIcon", {
                      staticClass: "w-4 h-4",
                      attrs: { icon: "warning", color: "tomato-7" }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.appointment.client && _vm.appointment.client.name
                  ? _c("BlTextBody2", {
                      staticClass: "truncate text-slate-1000",
                      attrs: {
                        title: _vm.appointment.client.name,
                        text: _vm.appointment.client.name
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isOrphan
                  ? _c("BlInputButton", {
                      staticClass: "ml-auto",
                      attrs: {
                        type: "outlined",
                        label: "Reschedule",
                        dense: ""
                      },
                      on: {
                        clicked: function($event) {
                          _vm.rescheduleOpened = true
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex items-center flex-shrink-0 w-40 px-4 border-b bg-pure-white border-slate-400"
        },
        [
          _vm.isOrphan
            ? _c("BlChip", {
                attrs: {
                  chip: "No therapist assigned",
                  color: "tomato",
                  dense: ""
                }
              })
            : _c("BlChip", {
                attrs: { chip: _vm.appointment.status, dense: "" }
              })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex items-center flex-shrink-0 w-40 pl-4 border-b bg-pure-white border-slate-400"
        },
        [
          _c("BlTextBody2", {
            attrs: { text: _vm.displayDate(_vm.appointment.date) }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex items-center flex-shrink-0 w-40 px-4 border-b bg-pure-white border-slate-400"
        },
        [
          _c("BlTextBody2", {
            attrs: {
              text:
                _vm.appointment.start_time_string +
                " - " +
                _vm.appointment.end_time_string
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.enableBranch
        ? _c(
            "div",
            {
              staticClass:
                "flex items-center flex-shrink-0 px-4 border-b bg-pure-white w-50 border-slate-400"
            },
            [
              !_vm.appointment.room.branch
                ? _c("BlTextBody2", { attrs: { text: "-" } })
                : _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-center px-2 truncate rounded h-7",
                      style: {
                        backgroundColor:
                          _vm.appointment.room.branch.background_color ||
                          "unset"
                      },
                      attrs: { title: _vm.appointment.room.branch.name }
                    },
                    [
                      _c("BlTextBody2", {
                        staticClass: "truncate",
                        style: {
                          color: _vm.appointment.room.branch.color || "unset"
                        },
                        attrs: { text: _vm.appointment.room.branch.name || "-" }
                      })
                    ],
                    1
                  )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex items-center flex-shrink-0 px-4 border-b bg-pure-white w-50 border-slate-400",
          attrs: { title: _vm.appointment.room.name }
        },
        [
          _c("BlTextBody2", {
            staticClass: "truncate",
            attrs: { text: _vm.appointment.room.name }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex items-center flex-shrink-0 px-4 border-b bg-pure-white w-50 border-slate-400"
        },
        [
          !_vm.appointment.user
            ? _c("BlTextBody2", {
                staticClass: "truncate",
                attrs: { text: "-" }
              })
            : _c("BlTextBody2", {
                staticClass: "truncate",
                class: { "italic ": !_vm.appointment.user.name },
                attrs: {
                  title: _vm.appointment.user.name || "Deleted user",
                  text: _vm.appointment.user.name || "Deleted user"
                }
              })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex items-center flex-shrink-0 px-4 border-b bg-pure-white w-80 border-slate-400"
        },
        [
          _vm.appointment.supervisors.length
            ? _c("BlTextBody2", {
                staticClass: "truncate",
                attrs: {
                  text: _vm.appointment.supervisors
                    .map(function(i) {
                      return i.name
                    })
                    .join(", "),
                  title: _vm.appointment.supervisors
                    .map(function(i) {
                      return i.name
                    })
                    .join(", ")
                }
              })
            : _c("BlTextBody2", { attrs: { text: "-" } })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex items-center flex-grow flex-shrink-0 px-4 border-b bg-pure-white w-80 border-slate-400",
          attrs: { title: _vm.reasonText }
        },
        [
          _c("BlTextBody2", {
            staticClass: "truncate whitespace-pre-line capitalize-first",
            attrs: { text: _vm.reasonText }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "sticky right-0 z-10 flex pr-6 bg-slate-100" }, [
        _c(
          "div",
          {
            staticClass:
              "flex items-center justify-center flex-shrink-0 gap-2 border-b border-r bg-pure-white w-14 border-slate-400",
            class: { "rounded-br": _vm.isLast }
          },
          [
            _vm.appointment.status !== "booking_in_progress" &&
            _vm.appointment.status !== "booking_in_review"
              ? _c(
                  "div",
                  { staticClass: "relative z-10" },
                  [
                    _c("BlInputButton", {
                      staticClass:
                        "flex items-center justify-center w-6 h-6 hover:bg-hover-state",
                      attrs: { icon: "dots-vertical", type: "plain" },
                      on: {
                        clicked: function($event) {
                          _vm.menuOpened = !_vm.menuOpened
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.menuOpened
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "absolute top-0 z-50 flex flex-col gap-1 p-2 mr-4 border rounded right-full bg-pure-white border-slate-400"
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass:
                                  "px-4 py-2 text-left transition-all duration-300 rounded outline-none hover:bg-hover-state min-w-56",
                                attrs: {
                                  to:
                                    "/appointments/details/" +
                                    _vm.appointment.id,
                                  target: "_blank"
                                }
                              },
                              [
                                _c("BlTextBody2", {
                                  staticClass: "text-slate-1000",
                                  attrs: { text: "View appointment details" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.currentUser.role.includes("admin")
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "px-4 py-2 text-left transition-all duration-300 rounded outline-none min-w-56",
                                    class: [
                                      _vm.appointment.status !== "scheduled"
                                        ? "opacity-50 cursor-not-allowed"
                                        : "hover:bg-hover-state"
                                    ],
                                    attrs: {
                                      disabled:
                                        _vm.appointment.status !== "scheduled"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.rescheduleOpened = true
                                      }
                                    }
                                  },
                                  [
                                    _c("BlTextBody2", {
                                      staticClass: "text-slate-1000",
                                      attrs: { text: "Reschedule appointment" }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentUser.role.includes("admin")
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "px-4 py-2 text-left transition-all duration-300 rounded outline-none min-w-56",
                                    class: [
                                      _vm.appointment.status === "cancelled" ||
                                      _vm.appointment.status === "completed"
                                        ? "opacity-50 cursor-not-allowed"
                                        : "hover:bg-hover-state"
                                    ],
                                    attrs: {
                                      disabled:
                                        _vm.appointment.status ===
                                          "cancelled" ||
                                        _vm.appointment.status === "completed"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.cancelOpened = true
                                      }
                                    }
                                  },
                                  [
                                    _c("BlTextBody2", {
                                      staticClass: "text-error-400",
                                      attrs: { text: "Cancel appointment" }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _vm.rescheduleOpened && _vm.currentUser.role.includes("admin")
        ? _c("RescheduleAppointmentOverlay", {
            attrs: { appointmentId: _vm.appointment.id },
            on: {
              "close-modal": function($event) {
                _vm.rescheduleOpened = false
              },
              "after-commit": function($event) {
                return _vm.$emit("after-commit")
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.cancelOpened && _vm.currentUser.role.includes("admin")
        ? _c("CancelAppointmentModal", {
            attrs: { appointmentId: _vm.appointment.id },
            on: {
              "close-modal": function($event) {
                _vm.cancelOpened = false
              },
              "after-commit": function($event) {
                return _vm.$emit("after-commit")
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8caee0a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8caee0a2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointments/table/Item.vue
// module id = null
// module chunks = 